import React, { useEffect, useState, forwardRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import HTMLReactParser from "html-react-parser";

import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import htmlParser from "html-react-parser";
import dayjs from "dayjs";
import { CiUser } from "react-icons/ci";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./SignupForm.css";

function trim(theStr) {
  return theStr.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}

function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
  var retVal = "";
  var okChars = "0123456789";
  var tmpVal = trim(inVal);
  var curChar = "";
  var isDotFound = false;

  if (tmpVal !== "") {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);

      if (okChars.indexOf(curChar) !== -1) {
        if (!isDotFound && curChar === "." && isDouble) {
          isDotFound = true;
          retVal = retVal + ".";
        }

        if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }

  return retVal;
}

function serialize(form) {
  let inputs = form.elements;
  let testArray = {};
  for (let i = 0; i < inputs.length - 1; i++) {
    testArray[inputs[i].id] = inputs[i].value;
  }
  return testArray;
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getFormURL() {
  if (
    window.location.href.split("/")[3] &&
    window.location.href.split("/")[4]
  ) {
    const temp = window.location.href.split("/")[4].replace("#", "");
    return "/" + window.location.href.split("/")[3] + "/" + temp;
  } else {
    return "/";
  }
}

export default function SignUpForm({ loanOfficer, closeForm, setShowSuccessModal, setShowFailModal, requestFromModal }) {
  const [validated, setValidated] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [leadNo, setLeadNo] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [consentValue, setConsentValue] = useState(true);
  // const [consentValueSlot, setConsentValueSlot] = useState(true);
  const [showContactForm, setShowContactForm] = useState(true);
  const [showConsenSection, setShowConsenSection] = useState(false);
  //   const [showSuccessModal, setShowSuccessModal] = useState(false);
  //   const [showFailModal, setShowFailModal] = useState(false);
  const [showClickToMoreOpt, setShowClickToMoreOpt] = useState(true);
  const [referrerName, setReferrerName] = useState("");
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");
  const [validationNote, setValidationNote] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [activeDates, setActiveDates] = useState([]);
  const [activeTimeSlots, setActiveTimeSlots] = useState([]);
  const [activeDays, setActiveDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState(null);
  const [dateInvalid, setDateInvalid] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showSuccessModal1, setShowSuccessModal1] = useState(false);
  const [showFailModal1, setShowFailModal1] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get("key");
  const utmSource = queryParams.get("utm_source") || undefined;
  const utmMedium = queryParams.get("utm_medium") || undefined;
  const utmCampaign = queryParams.get("utm_campaign") || undefined;
  const utmContent = queryParams.get("utm_content") || undefined;


  useEffect(() => {
    const fetchData = () => {
      if (
        loanOfficer &&
        loanOfficer.slots &&
        loanOfficer.slots.hosts.length > 0
      ) {
        const hosts = loanOfficer.slots.hosts;
        const activeDates = [];
        const activeDays = [];
        const activeTimeSlots = [];

        hosts.forEach((host) => {
          host.availability.forEach((availability) => {
            if (
              availability.activeDates &&
              availability.activeDates.length > 0
            ) {
              activeDates.push(...availability.activeDates);
            }

            if (availability.activeDays && availability.activeDays.length > 0) {
              activeDays.push(...availability.activeDays);
            }

            if (
              availability.activeTimeSlots &&
              availability.activeTimeSlots.length > 0
            ) {
              activeTimeSlots.push(...availability.activeTimeSlots);
            }
          });
        });

        setActiveDates(activeDates);
        setActiveDays(activeDays);
        setActiveTimeSlots(activeTimeSlots);
      }
    };

    fetchData();
  }, [loanOfficer]);

  const formatDateString = (date) => {
    return dayjs(date).format("YYYY-MM-DD");
  };

  const handleDateChange = (date) => {
    if (!date) {
      // If no date is selected, set dateInvalid to true
      setDateInvalid(true);
      setSelectedDate(null);
      setSelectedTime("");
      return;
    }

    setSelectedDate(date);

    const formattedDate = formatDateString(date);
    const dayOfWeek = dayjs(date).format("dddd").toLowerCase();

    // Find the availability for the selected day
    const availability = loanOfficer.slots.hosts[0].availability.find(
      (entry) => {
        const isDateAvailable =
          entry.activeDates && entry.activeDates.includes(formattedDate);
        const isDayAvailable =
          entry.activeDays &&
          entry.activeDays.some((day) => day.toLowerCase() === dayOfWeek);
        return isDateAvailable || isDayAvailable;
      }
    );

    // Set active time slots for the selected date
    if (availability) {
      setActiveTimeSlots(availability.activeTimeSlots);
    } else {
      setActiveTimeSlots([]);
    }

    // If date is selected, set dateInvalid to false
    setDateInvalid(false);
  };

  const handleTimeChange = (e) => {
    const time = e.target.value;
    setSelectedTime(time);
  };

  const generateDatesFromDays = () => {
    const currentDate = dayjs();
    const days = activeDays.map((day) => day.toLowerCase());

    const generatedDates = [];
    for (let i = 0; i < 365; i++) {
      const date = currentDate.add(i, "day");
      const dayOfWeek = dayjs(date).format("dddd").toLowerCase();
      if (
        days.includes(dayOfWeek) ||
        activeDates.includes(date.format("YYYY-MM-DD"))
      ) {
        generatedDates.push(date.toDate());
      }
    }
    return generatedDates;
  };

  // const handleTimeChange = (e) => {
  //   const time = e.target.value;
  //   setSelectedTime(time);
  // };

  const handleFailClose = () => {
    setShowFailModal(false);
    setValidated(false);
  };
  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setValidated(false);
  };

  const clearForm = () => {
    setLeadNo("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setComment("");
    setMessage("");
    setReferrerName("");
    setConsentValue(true);
    setValidationNote("");
    setSelectedDate("");
    setSelectedTime("");
    setCompanyName("");
  };

  const goBackToFirstPage = () => setShowConsenSection(false);

  //Below is the function to remove non-printable ASCII chars
  //and special chars from the pass string
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === "") {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }

  //first name validation
  const handleFirstName = (evt) => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    if (tempFirstName) {
      if (tempFirstName.includes(" ") && lastName === "") {
        const name = tempFirstName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setFirstName(tempFirstName.trim());
      }
    } else {
      setFirstName("");
    }
  };


  const domainName = 'swmc.com';
  const language = 'en';

  const [consentData, setConsentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchConsentData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_LEAD_GENERATION_CONSENT_JSON}?t=${Date.now()}`);
      const data = await response.json();

      const selectedDomain = data[domainName] ? domainName : 'swmc.com';
      const domainData = data[selectedDomain];

      const consent = {
        submitButtonConsent: domainData.submit_button_consent[language],
        automatedPhoneSolicitationConsent: domainData.automated_phone_solicitation_consent[language],
        version: domainData.version,
      };

      setConsentData(consent);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchConsentData();
  }, []);

  useEffect(() => {
    if (consentData) {
      const consentElement = document.querySelector('.button-name');
      if (consentElement) {
        consentElement.innerText = 'clicking Continue';
      }
    }
  }, [consentData]);

  //last name validation
  const handleLastName = (evt) => {
    let tempLastName = evt.currentTarget.value;
    tempLastName = removeNonAsciiSpecialCharacters(tempLastName);
    if (tempLastName) {
      if (tempLastName.includes(" ") && firstName === "") {
        const name = tempLastName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setLastName(tempLastName.trim());
      }
    } else {
      setLastName("");
    }
  };

  const handleReferrerName = (e) => {
    setReferrerName(e.target.value);
  };

  const handleEmailAddress = (evt) => {
    let tempEmailAddress = evt.currentTarget.value;
    if (tempEmailAddress) {
      setEmail(tempEmailAddress.trim());
    } else {
      setEmail("");
    }
  };

  // Phone number validation
  const handleTelephoneNumber = (evt) => {
    //Save Phone number in local storage for Apply
    var tmpVal = trim(getNumbers(evt.currentTarget.value, false, "01"));
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
                456, 555, 900,
                100, 101, ..., 199
                211, 311, ..., 911  ***811 removed
                370, 371, ..., 379
                960, 961, ..., 969
                800, 801, ..., 855  ***removed
                866, 877, 888, 800855
                */
    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = "";
      return;
    }

    var curChar = "";
    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = "";

    /* Do not put the parentesis if we only have the first three digits of the phone number.
                Once we are past that then start formatting the phone number. This was the main issue
                why the phone number couldn't be blanked out in it's entirety.*/
    if (areaCode !== "" && firstThree === "") retVal += areaCode;
    else if (areaCode !== "" && firstThree !== "")
      retVal += "(" + areaCode + ")";

    if (firstThree !== "") retVal += " " + firstThree;

    if (lastFour !== "") retVal += "-" + lastFour;

    if (extension !== "") retVal += " x" + extension;
    else setPhone(retVal);
  };

  const showPhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(false);
  };

  const hidePhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setFormLoading(true);
      const signupFormData = document.querySelector("#signupForm");
      const getData = serialize(signupFormData);
      const signupForm = document.getElementById("signupForm");
      if (!showConsenSection) {
        const firstName_ = getData.firstName?.trim() || ""; // Safely access and trim the first name
        const lastName_ = getData.lastName?.trim() || ""; // Safely access and trim the last name
        
        const phoneNumber_ = getData.phone;
        const email_ = getData.email;
        const companyName_ = getData.companyName;
        const comments_ = getData.comment;
        let formUrl = getFormURL();
        const chs_name = getData["chs:name"];
        const consent_version = consentData ? consentData.version : undefined;
        const consent_version_text = consentData ? consentData.automatedPhoneSolicitationConsent.content : undefined;


        axios
          .post(process.env.REACT_APP_API_EMAIL, {
            firstName: firstName_,
            lastName: lastName_,
            phone: phoneNumber_,
            email: email_,
            companyName: companyName_,
            referrerSource: "DSCRHELOC1TO4UNITS",
            comments: comments_,
            "chs:name": chs_name,
            utmSource: utmSource,
            utmMedium: utmMedium,
            utmCampaign: utmCampaign,
            utmContent: utmContent,
            formUrl: formUrl,
            leadSource: "DSCRHELOC1TO4UNITS",
            TCPA_Consent_Given: phoneNumber_ ? consentValue : undefined,
            consentVersion: phoneNumber_ ? consent_version : undefined,
            consentVersionText: phoneNumber_ ? consent_version_text : undefined,
          })
          .then((res) => {
            setLeadNo(res.data.success.brokerId);
            // If phone number is provided, show consent section; otherwise submit directly
            if (phoneNumber_) {
              setShowConsenSection(true);
              setFormLoading(false);
            } else {
              // No phone number, skip consent and complete submission
              if (requestFromModal) {
                setShowContactForm(true);
                setShowSuccessModal(true);
                closeForm();
                signupForm.classList.remove("was-validated");
                signupForm.reset();
                clearForm();
              }
              setShowContactForm(true);
              setShowSuccessModal1(true);
              signupForm.classList.remove("was-validated");
              signupForm.reset();
              clearForm();
              setFormLoading(false);
            }
          })
          .catch(function (error) {
            setShowFailModal(true);
            setShowSuccessModal(false);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            setFormLoading(false);
          });
      } else {
        // We need to update the details of lead again as there might be the case user may
        // select I do not consent in the consent section after lead is generated
  
        const firstName_ = getData.firstName?.trim() || ""; // Safely access and trim the first name
        const lastName_ = getData.lastName?.trim() || ""; // Safely access and trim the last name

        const phoneNumber_ = getData.phone;
        const email_ = getData.email;
        const comments_ = getData.comment;
        const consent_version = consentData ? consentData.version : undefined;
        const consent_version_text = consentData ? consentData.automatedPhoneSolicitationConsent.content : undefined;
        const companyName_ = getData.companyName;
        axios
          .post(process.env.REACT_APP_API_EMAIL, {
            leadId: leadNo,
            firstName: firstName_,
            lastName: lastName_,
            phone: phoneNumber_,
            email: email_,
            comments: comments_,
            companyName: companyName_,
            leadSource: "DSCRHELOC1TO4UNITS",
            TCPA_Consent_Given: consentValue,
            consentVersion: consent_version,
            consentVersionText: consent_version_text,
          })
          .then((res) => {
            if (requestFromModal) {
              setLeadNo(leadNo);
              setShowContactForm(true);
              setShowSuccessModal(true);
              closeForm();
              setShowConsenSection(false);
              signupForm.classList.remove("was-validated");
              signupForm.reset();
              clearForm();
              setFormLoading(false);
            }
            setLeadNo(leadNo);
            setShowContactForm(true);
            setShowConsenSection(false);
            setShowSuccessModal1(true);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            clearForm();
            setFormLoading(false);
            // closeForm();
            // setShowSuccessModal1(true);
          })
          .catch(function (error) {
            if (requestFromModal) {
              setShowFailModal(true);
              setShowSuccessModal(false);
              signupForm.classList.remove("was-validated");
              signupForm.reset();
              setFormLoading(false);
            }
            setShowFailModal1(true);
            setShowSuccessModal1(false);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            setFormLoading(false);
          });
      }
    }
    setValidated(true);
  };
  useEffect(() => {
    if (key) {
      axios
        .post(
          process.env.REACT_APP_SUNSOFT_API_GET_SESSION_KEY,
          { key: key },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          let userData = response.data.parameters;
          if (userData.borrowerName) {
            // If the borrower name contains a space, split the first and last name.
            let name = userData.borrowerName.split(" ");
            setFirstName(name[0]);
            setLastName(name.slice(1).join(" "));
          } else {
            // If there is no borrower name, set the first and last name accordingly.
            if (userData.borrowerFirstName) {
              setFirstName(userData.borrowerFirstName);
            }
            if (userData.borrowerLastName) {
              setLastName(userData.borrowerLastName);
            }
          }
          setPhone(userData.borrowerPhone);
          setEmail(userData.emailAddress);
          setCompanyName(userData.companyName);
          return response;
        })
        .catch((error) => {
          // console.error("Get GET_SESSION_KEY Error: ", error);
        });
    }
  }, []);

  const CustomDatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      readOnly // Make the input field read-only
      placeholder="Select Date"
      required
      ref={ref} // Forward the ref to the input element
    />
  ));

  return (
    <div className="formWrapper pad-form" id="ContactForm">
      <Container>
        <div className="formBody">
          <Container className="form-container">
            <Row>
              <Col sm={12} className="ContactUsFormBox">

                {showContactForm && (
                  <Form
                    id="signupForm"
                    autoComplete="off"
                    method="POST"
                    noValidate
                    onSubmit={handleSubmit}
                    validated={validated}
                  >
                    <Row>
                      <Col sm={12} className="d-none">
                        <Form.Group controlId="leadNo" className="form-group">
                          <Form.Control
                            aria-label="Lead Number"
                            placeholder="Lead Number"
                            type="text"
                            value={leadNo}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group
                          controlId="firstName"
                          className="form-group"
                        >
                          <InputGroup className="mb-3">

                            <Form.Control
                              aria-label="First Name"
                              onChange={(e) => setFirstName(e.target.value)}
                              onBlur={handleFirstName}
                              placeholder="First Name"
                              required={lastName === ""}
                              type="text"
                              value={firstName}
                              className={firstName ? "active" : ""}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid First Name.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="lastName" className="form-group">
                          <InputGroup className="mb-3">

                            <Form.Control
                              aria-label="First Name"
                              onChange={(e) => setLastName(e.target.value)}
                              placeholder="Last Name"
                              onBlur={handleLastName}
                              required={firstName === ""}
                              type="text"
                              value={lastName}
                              className={lastName ? "active" : ""}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid First Name.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="email" className="form-group">
                          <InputGroup className="mb-3">

                            <Form.Control
                              aria-label="Email Address"
                              onChange={handleEmailAddress}
                              pattern="^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]{2,64})$"
                              placeholder="Email Address"
                              required
                              type="text"
                              value={email}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Email Address.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={6}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="phone" className="form-group">
                          <InputGroup className="mb-3">

                            <Form.Control
                              aria-label="Telephone Number"
                              maxLength={21}
                              minLength={14}
                              onChange={handleTelephoneNumber}
                              pattern="^(\(\d{3}\)|\d{3})-?\s?\d{3}-?\s?\d{4}( ?x\d{1,7})?$"
                              placeholder="Telephone Number"
                              required={email === ""}
                              type="text"
                              value={phone}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Telephone Number.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="companyName" className="form-group">
                          <Form.Control
                            type="text"
                            aria-label="Company Name"
                            placeholder="Company Name"
                            className="mb-3"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="comment" className="form-group">
                          <Form.Control
                            rows="3"
                            aria-label="comment"
                            placeholder="Message"
                            as="textarea"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                          />
                        </Form.Group>
                      </Col>

                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <div className="d-flex">
                          {showClickToMoreOpt ? (
                            <h6
                              className="consentSmall"
                              onClick={showPhoneSoliticationConsent}
                            >
                              {
                                "Do you consent to Automated Phone Solicitation?"
                              }{" "}
                              <span
                                id="showConsentText"
                                className="consentLink showConsentText"
                                title="Show Phone Solicitation Consent"
                              >
                                (click to show more)
                              </span>
                            </h6>
                          ) : (
                            <h6
                              className="consentSmall"
                              onClick={hidePhoneSoliticationConsent}
                            >
                              {
                                "Do you consent to Automated Phone Solicitation?"
                              }{" "}
                              <span
                                id="hideConsentText"
                                className="consentLink hideConsentText"
                                title="Hide Phone Solicitation Consent"
                              >
                                (click to show less)
                              </span>
                            </h6>
                          )}
                        </div>

                        {!showClickToMoreOpt ? (
                          <p
                            id="phoneSolicitationTerms"
                            className="consent-font pb-0"
                          >
                            {consentData?.automatedPhoneSolicitationConsent && (
                              <>
                                {HTMLReactParser(consentData.automatedPhoneSolicitationConsent.content)}
                              </>
                            )}


                          </p>
                        ) : (
                          ""
                        )}
                      </Col>

                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <Form.Check
                          aria-label="I Consent"
                          defaultChecked
                          className="checkIConsent"
                          id="iConsentSlot"
                          label="I Consent"
                          name="checkIConsent"
                          onClick={() => {
                            setConsentValue(true);
                        }}
                          type="radio"
                        />
                        <Form.Check
                          aria-label="I DO NOT Consent"
                          className="checkIConsent"
                          id="iDoNotConsentSlot"
                          label="I DO NOT Consent"
                          name="checkIConsent"
                          onClick={() => {
                            setConsentValue(false);
                        }}
                          type="radio"
                        />
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        {consentData?.submitButtonConsent && (
                          <p className="consent-font">
                            {HTMLReactParser(consentData.submitButtonConsent.content)}
                          </p>
                        )}

                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <div className="divflex">
                          <div>
                            <Button className="btn-submit btn-getstarted" type="submit">
                              {formLoading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    aria-hidden="true"
                                    as="span"
                                    role="status"
                                    size="md"
                                  />{" "}
                                  Please wait...
                                </>
                              ) : (
                                <>Continue</>
                              )}
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <div className="divflex">
                          <div className="backBtnDiv">
                            <Button
                              className="btn-submit"
                              type="button"
                              onClick={goBackToFirstPage}
                            >
                              <>Back</>
                            </Button>
                          </div>
                          <div className="continueBtnDiv btnAdjustDiv">
                            <Button
                              className="btn-submit"
                              type="submit"
                              variant="success"
                            >
                              {formLoading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    aria-hidden="true"
                                    as="span"
                                    role="status"
                                    size="sm"
                                  />{" "}
                                  Please wait...
                                </>
                              ) : (
                                <>Submit</>
                              )}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Col>
            </Row>
          </Container>

        </div>
      </Container>

    </div>
  );
}